import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../Roles and Permissions/Filters/Date";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import MultiSelect from "../../Roles and Permissions/Filters/MultiSelect";
import AddWaste from "./AddWaste";
import ViewWaste from "./ViewWaste";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../Layout/MastersSidebar";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getFacilityName,
  isFacilityHeading,
  shouldShowFacilityColumn,
  withFacilityHeading, FacilityDataCell, MasterDateDataCell } from "../../../../utils/facilityColumn";

const WasteData = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = showFacilityColumn
    ? "11% 11% 22% 24% 22% 8%"
    : "12% 25% 27% 26% 8%";
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Facility: false,
    "Type of waste management": false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    Facility: false,
    "Type of waste management": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    facility: [],
    wasteManagementType: [],
  });
  const filters = user?.facilityManger
    ? ["Date", "Type of waste management"]
    : ["Date", "Facility", "Type of waste management"];
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    facility: [],
    wasteManagementType: [],
  });

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height
      setIsShortContent(tableHeight * 2 < screenHeight);
    }
  }, [data]);

  const inputData = [
    {
      fieldName: "vendorLegalName",
      title: "Vendor Legal Name",
      placeholder: "Enter Name",
    },
    // {
    //   fieldName: "facility",
    //   title: "Facility",
    //   placeholder: "Select type",
    //   type: "select",
    //   url: `${api}/master/getAllFacility`,
    //   field: "facilityName",
    // },
    {
      fieldName: "wasteManagementType",
      title: "Type of Waste Management",
      type: "select",
      options: ["Recycling", "Landfilling", "Incineration", "Composting"],
      placeholder: "Select type",
    },
    {
      fieldName: "govtVendorRegistrationNumber",
      title: "Govt. Vendor Registration Number",
      placeholder: "Enter Registration Number",
    },
    {
      fieldName: "documents",
      title: "Upload Documents",
      type: "file",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/master/wasteManagement`);
      const data = response.data.data;
      const uniqueFacilities = [
        ...new Set(
          data.map((el) => el.facilityName).filter(Boolean) // Filter out undefined values
        ),
      ];

      const uniqueTypeofWasteGenerated = [
        ...new Set(
          data.map((el) => el.wasteManagementType).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        facility: uniqueFacilities,
        wasteManagementType: uniqueTypeofWasteGenerated,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(`/master/wasteManagement?${queryParams}`);
      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    facility: tempFilter?.facility.join(","),
    wasteManagementType: tempFilter?.wasteManagementType.join(","),
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    setPage(1);
    setStartDate(tempFilter.startDate);
    setEndDate(tempFilter.endDate);
    setSelectedFields({
      facility: tempFilter.facility,
      wasteManagementType: tempFilter.wasteManagementType,
    });
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setTempFilter({
      startDate: null,
      endDate: null,
      facility: [],
      wasteManagementType: [],
    });
    setSelectedFields({
      facility: [],
      wasteManagementType: [],
    });
    setStartDate(null);
    setEndDate(null);
    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied =
      tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isFacilityApplied = tempFilter?.facility?.length > 0 ? true : false;
    const isWasteManagementTypeApplied =
      tempFilter?.wasteManagementType?.length > 0 ? true : false;

    setIsFiltersApplied(
      isDateApplied || isFacilityApplied || isWasteManagementTypeApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Facility: isFacilityApplied,
      "Type of waste management": isWasteManagementTypeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      facility: selectedFields.facility,
      wasteManagementType: selectedFields.wasteManagementType,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = withFacilityHeading(
    [
      { title: "Date", field: "createdAt" },
      { title: "Vendor Legal Name", field: "vendorLegalName" },
      { title: "Type of Waste Management", field: "wasteManagementType" },
      {
        title: "Govt. Vendor Registration Number",
        field: "govtVendorRegistrationNumber",
      },
    ],
    showFacilityColumn,
    "field"
  );

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );


      case "Type of waste management":
        return (
          <MultiSelect
            title="Type of waste management"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  wasteManagementType: newValue.wasteManagementType || newValue,
                };
              });
            }}
            errors={errors["Type of waste management"]}
            setErrors={setErrors}
            field="wasteManagementType"
            data={uniqueValues.wasteManagementType}
          />
        );
      default:
        return null;
    }
  };

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddWaste
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={data}
            element={element}
            addUrl={`${api}/master/wasteManagement`}
            updateUrl={`${api}/master/wasteManagement`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <ViewWaste
            id={element ? element._id : ""}
            data={element}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          {/* {deleteDialog && (
          <DeleteDialog
            {...{ deleteDialog, setDeleteDialog, handleDeleteAggree }}
          />
        )} */}
          {deleteDialog && (
            <DeleteDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/master/wasteManagement`,
                method: "delete",
                setsnackOpen,
              }}
            />
          )}
          {/* Filter Drawer */}
          {/* <Toolbar sx={{ marginBottom: "20px", marginTop: "3%" ,ml:0 }}> */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenu
            setData={setElement}
            setAddData={setAddData}
            {...{
              heading: "Scope 3",
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            sx={{ marginBottom: "1rem" }}
            ref={tableContainerRef}
          >
            <Box>
              <TableHeading heading={"Waste Management Vendor"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  ...(showFacilityColumn && { alignItems: "stretch" }),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) =>
                  isFacilityHeading(el) ? (
                    <FacilityColumnHeading
                      key={el.field}
                      handleSort={handleSort}
                      sortConfig={sortConfig}
                    />
                  ) : (
                    <ColumnHeadings
                      key={el.title}
                      {...{
                        title: el.title,
                        key: el.title,
                        handleSort,
                        field: el.field,
                        sortConfig,
                      }}
                    />
                  )
                )}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                // <Box sx={{ mt: "14%", mb: "14%" }}>
                <NoDataFound />
              ) : (
                // </Box>
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      ...(showFacilityColumn && { alignItems: "stretch" }),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) =>
                      isFacilityHeading(el) ? (
                        <FacilityDataCell key={el.field}>
                          {getFacilityName(item) || "N/A"}
                        </FacilityDataCell>
                      ) : (
                        <TableContent
                          key={el.field}
                          {...{
                            fieldData: item[el.field],
                            dateField:
                              el.field === "createdAt" ? item.createdAt : false,
                          }}
                        />
                      )
                    )}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent} // Pass this state to PaginationBox
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default WasteData;
